export const municipalityRegionMap: Record<string, 'north' | 'south' | 'west' | 'east' | 'central' | 'piraeus' | 'islands'> = {
  // Κεντρικός Τομέας
  athina: 'central', dafni_ymittos: 'central', galatsi: 'central', kaisariani: 'central', vyronas: 'central', zografou: 'central', ilioupoli: 'central', filadelfeia_chalkidona: 'central',
  // Βόρεια
  agia_paraskevi: 'north', irakleio: 'north', kifisia: 'north', lykovrysi_pefki: 'north', marousi: 'north', metamorfosi: 'north',
  nea_ionia: 'north', papagou_cholargos: 'north', penteli: 'north', vrilissia: 'north', chalandri: 'north', filothei_psychiko: 'north',
  // Δυτικά
  aigaleo: 'west', agioi_anargyroi_kamatero: 'west', chaidari: 'west', ilion: 'west', peristeri: 'west', petroupoli: 'west', agia_varvara: 'west',
  // Νότια
  agios_dimitrios: 'south', alimos: 'south', elliniko_argyroupoli: 'south', glyfada: 'south', kallithea: 'south', moschato_tavros: 'south',
  nea_smyrni: 'south', palaio_faliro: 'south',
  // Πειραιάς
  piraeus: 'piraeus', keratsini_drapetsona: 'piraeus', korydallos: 'piraeus', nikaia_agios_ioannis_rentis: 'piraeus', perama: 'piraeus',
  // Ανατολική Αττική
  acharnes: 'east', dionysos: 'east', kropia: 'east', lavreotiki: 'east', marathonas: 'east', markopoulo_mesogaias: 'east',
  oropos: 'east', paiania: 'east', pallini: 'east', rafina_pikermi: 'east', saronikos: 'east', spata_artemida: 'east', vari_voula_vouliagmeni: 'east',
  // Δυτική Αττική
  aspropyrgos: 'west', elefsina: 'west', fyli: 'west', megara: 'west', mandra_eidyllia: 'west',
  // Νήσων
  aegina: 'islands', agistri: 'islands', salamina: 'islands', troizinia_methana: 'islands', kythira: 'islands', spetses: 'islands', hydra: 'islands', poros: 'islands',
};
